import { PhoneNumberE164, toPhoneNumberE164 } from "@sp-crm/core";
import { PhoneInputE164 } from "components/shared/phone-input-e164";
import * as React from "react";
import { InDepthQuestionProps } from "./props";

export class PhoneQuestion extends React.Component<InDepthQuestionProps, undefined> {
    constructor(props: InDepthQuestionProps) {
        super(props);
        this.updateAnswer = this.updateAnswer.bind(this);
    }

    updateAnswer(newVal: PhoneNumberE164): void {
        this.props.requestAnswerModification(a => {
            a.textAnswer = newVal;
        });
    }

    render(): JSX.Element {
        return (
            <PhoneInputE164
                onCommit={this.updateAnswer}
                initial={toPhoneNumberE164(this.props.answer.textAnswer)}
                key={this.props.question.id}
                label={this.props.question.title}
            />
        );
    }
}
